(function () {
    'use strict';

    angular
        .module('app.iCal')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                  state: 'ical',
                  config: {
                      abstract: true,
                      url: '/ical',
                      template: '<ui-view/>'
                  }
              },
            {
                state: 'ical.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/iCal/list.html?v=' + opsIncludeVersion,
                    controller: 'ICalListController',
                    controllerAs: 'vm',
                    title: 'iCal Feeds',
                    settings: {
                        authMode: 1
                    },
                    resolve: {
                        authenticationRequired: ['userService', function (userService) {
                            if (userService.userType() == "0") {
                                throw { name: "NotAdmin" };
                            }
                        }]
                    }
                }
            },
            {
             state: 'ical.details',
             config: {
                 url: '/detail/:id',
                 templateUrl: 'app/iCal/details.html?v=' + opsIncludeVersion,
                 controller: 'ICalDetailsController',
                 controllerAs: 'vm',
                 title: 'iCal Details',
                 settings: {
                     authMode: 1
                 },
                 resolve: {
                     authenticationRequired: ['userService', function (userService) {
                         if (userService.userType() == "0") {
                             throw { name: "NotAdmin" };
                         }
                     }]
                 }
             }
            }
         
        ];
    }
})();
